export default "__VITE_ASSET__a0dbf74a__"